import React from 'react';
import { Box, Grid, Paper, Stack, Typography } from '@mui/material';

const pillars = [
  {
    title: 'Network',
    description:
      'We are a cross-generational community of students and alumni in Mexico working together to build opportunities for one another and our partners.',
  },
  {
    title: 'Impact',
    description:
      'Programming spans civic leadership, education, entrepreneurship, and cultural exchange, creating measurable change in the communities we serve.',
  },
  {
    title: 'Mentorship',
    description:
      'Members volunteer expertise through mentorship circles, professional workshops, and student support programs that foster long-term collaboration.',
  },
];

export default function AboutUs() {
  return (
    <Box>
      <Stack spacing={2} sx={{ mb: { xs: 4, md: 6 }, maxWidth: 720 }}>
        <Typography variant="overline" sx={{ letterSpacing: 4, color: 'primary.main' }}>
          About us
        </Typography>
        <Typography variant="h4">
          A platform for agents of change to partner with Mexico&apos;s changemakers.
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Crimson Club of Mexico amplifies ideas born in Cambridge and nurtured at home. We convene
          working groups, cultural experiences, and policy dialogues to inspire collective action.
        </Typography>
      </Stack>

      <Grid container spacing={{ xs: 3, md: 4 }}>
        {pillars.map((pillar) => (
          <Grid item xs={12} md={4} key={pillar.title}>
            <Paper
              elevation={0}
              sx={{
                height: '100%',
                p: { xs: 3, md: 4 },
                borderRadius: 4,
                border: '1px solid rgba(15,15,20,0.08)',
                boxShadow: '0 10px 30px rgba(15,15,25,0.08)',
                background: 'linear-gradient(180deg, #ffffff 0%, rgba(246,246,248,0.9) 100%)',
              }}
            >
              <Stack spacing={1.5}>
                <Typography variant="h6">{pillar.title}</Typography>
                <Typography variant="body2" color="text.secondary">
                  {pillar.description}
                </Typography>
              </Stack>
            </Paper>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
